import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';
import getClassName from 'src/common/utils/getClassName';

import s from './LoadingSpinner.module.scss';

const DefaultContent = (<>Just a sec...</>);

export type LoadingSpinnerProps = {
  children?: ReactNode;
  classNameModifier?: string;
  variant?: 'xl' | 'l' | 'm' | 's' | 'xs';
  spinnerOnly?: boolean;
  background?: boolean;
  noMargin?: boolean;
};

const LoadingSpinner: FC<LoadingSpinnerProps> = ({
  children = DefaultContent,
  classNameModifier = '',
  variant = 'xl',
  spinnerOnly = false,
  background = false,
  noMargin = false,
}) => (
  <div className={getClassName(s, 'root', classNames(classNameModifier, variant, { noMargin }))}>
    <div className={getClassName(s, 'spinnerWrapper', classNames({ background }))}>
      <div className={getClassName(s, 'spinner', variant)} />
    </div>
    {!spinnerOnly && <span className={getClassName(s, 'title', variant)}>{children}</span>}
  </div>
);

export default LoadingSpinner;
